import { useEffect } from "react"

export const useScrollLock = (locked: boolean, selectors: string[] = []) => {
  const selectorsString = selectors.join(",")

  useEffect(() => {
    if (!locked) return

    const elements: HTMLElement[] = []
    const originalStyles: string[] = []

    selectors.forEach((selector) => {
      const el = document.querySelector<HTMLElement>(selector)

      if (el) {
        elements.push(el)
        originalStyles.push(el.style.overflow)
        el.style.overflow = "hidden"
      }
    })

    return () => {
      elements.forEach((el, i) => {
        el.style.overflow = originalStyles[i]
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locked, selectorsString])
}
